module.exports = __webpack_public_path__ + "img/espired-logo.6f3810ff.png";